import Vue from 'vue'
import Router from 'vue-router'
// 首页
const index = () => import('@/pages/index/index');
// 期权
const shareOption = () => import('@/pages/shareOption/index');
// 外汇
const foreignTrading = () => import('@/pages/foreignTrading/index');
// 商品交易
const goodsTrading = () => import('@/pages/goodsTrading/index');
// 指数
const exponent = () => import('@/pages/exponent/index');
// 机构账户
const institutions = () => import('@/pages/institutions/index');
// 合作伙伴
const partners = () => import('@/pages/partners/index');
// 新闻
const news = () => import('@/pages/news/index');
// 公司概况
const situation = () => import('@/pages/situation/index');
// 交易平台
const tradingPlatform = () => import('@/pages/tradingPlatform/index');
// 下载
const download = () => import('@/pages/download/index');
// 培训支持
const training = () => import('@/pages/training/index');
// 法律文件
const legalDocument = () => import('@/pages/legalDocument/index');
// 场外交易
const otcTrading = () => import('@/pages/trading/index');
// 订单管理
const otcOrder = () => import('@/pages/order/index');
// 待办订单
const otcBacklogOrder = () => import('@/pages/backlogOrder/index');
// 机构账户
const joinUs = () => import('@/pages/joinUs/index');
// whyBpt
const whyBpt = () => import('@/pages/whyBpt/index');
// 帮助中心
const helpCenter = () => import('@/pages/helpCenter/index');
// 大宗商品
const commodities = () => import('@/pages/commodities/index');
// 市场范围
const marketScope = () => import('@/pages/marketScope/index');
// 外汇
const foreignExchange = () => import('@/pages/foreignExchange/index');
// 数字货币
const digitalCurrency = () => import('@/pages/digitalCurrency/index');
// 外汇交易的优势
const foreignExchangeTrading = () => import('@/pages/foreignExchangeTrading/index');
// 差价合约的优势
const contractDifference = () => import('@/pages/contractDifference/index');
// 商业合作
const cooperation = () => import('@/pages/cooperation/index');
// 财经日历
const economicCalendar = () => import('@/pages/economicCalendar/index');
// 新闻资讯
const newsInformation = () => import('@/pages/newsInformation/index');
// 财经快讯
const financialNews = () => import('@/pages/financialNews/index');
const companyAnnouncement = () => import('@/pages/companyAnnouncement/index');
const downloadGuide = () => import('@/pages/downloadGuide/index');

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/shareOption',
      name: 'shareOption',
      component: shareOption
    },
    {
      path: '/foreignTrading',
      name: 'foreignTrading',
      component: foreignTrading
    },
    {
      path: '/goodsTrading',
      name: 'goodsTrading',
      component: goodsTrading
    },
    {
      path: '/exponent',
      name: 'exponent',
      component: exponent
    },
    {
      path: '/institutions',
      name: 'institutions',
      component: joinUs
    },
    {
      path: '/partners',
      name: 'partners',
      component: partners
    },
    {
      path: '/news/:label',
      name: 'news',
      component: news
    },
    {
      path: '/situation',
      name: 'situation',
      component: situation
    },
    {
      path: '/tradingPlatform',
      name: 'tradingPlatform',
      component: tradingPlatform
    },
    {
      path: '/download',
      name: 'download',
      component: download
    },
    {
      path: '/training',
      name: 'training',
      component: training
    },
    {
      path: '/legalDocument/:label',
      name: 'legalDocument',
      component: legalDocument
    },
    {
      path: '/otcOrder',
      name: 'otcOrder',
      component: otcOrder
    },
    {
      path: '/otcTrading',
      name: 'otcTrading',
      component: otcTrading
    },
    {
      path: '/otcBacklogOrder',
      name: 'otcBacklogOrder',
      component: otcBacklogOrder
    },
    {
      path: '/joinUs',
      name: 'joinUs',
      component: joinUs
    },
    {
      path: '/whyBpt',
      name: 'whyBpt',
      component: whyBpt
    },
    {
      path: '/helpCenter',
      name: 'helpCenter',
      component: helpCenter
    },
    {
      path: '/commodities',
      name: 'commodities',
      component: commodities
    },
    {
      path: '/marketScope',
      name: 'marketScope',
      component: marketScope
    },
    {
      path: '/foreignExchange',
      name: 'foreignExchange',
      component: foreignExchange
    },
    {
      path: '/digitalCurrency',
      name: 'digitalCurrency',
      component: digitalCurrency
    },
    {
      path: '/foreignExchangeTrading',
      name: 'foreignExchangeTrading',
      component: foreignExchangeTrading
    },
    {
      path: '/contractDifference',
      name: 'contractDifference',
      component: contractDifference
    },
    {
      path: '/cooperation',
      name: 'cooperation',
      component: cooperation
    },
    {
      path: '/economicCalendar',
      name: 'economicCalendar',
      component: economicCalendar
    },
    {
      path: '/newsInformation',
      name: 'newsInformation',
      component: newsInformation
    },
    {
      path: '/financialNews',
      name: 'financialNews',
      component: financialNews
    },
    {
      path: '/companyAnnouncement',
      name: 'companyAnnouncement',
      component: companyAnnouncement
    },
    {
      path: '/downloadGuide',
      name: 'downloadGuide',
      component: downloadGuide
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js